<template>
  <div v-if="canShowSuggestedKeywords" class="suggest">
    <ul class="suggest__items">
      <li
        v-for="(suggestedKeyword, i) in suggestedKeywords"
        :key="i"
        class="suggest__items--item"
        @click="onClickSuggestedKeyword(suggestedKeyword.keyword)"
      >
        {{ suggestedKeyword.keyword }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    canShowSuggestedKeywords: {
      type: Boolean,
      required: true
    },
    suggestedKeywords: {
      type: Array,
      required: true
    }
  },
  methods: {
    onClickSuggestedKeyword(keyword) {
      this.$emit('click-suggested-keyword', keyword)
    }
  }
}
</script>
<style lang="scss" scoped>
.suggest {
  display: block;
  position: absolute;
  left: 0;
  width: 100%;
  margin-top: 17px;
  height: calc(100vh - 113px);
  background-color: white;
  overflow-y: scroll;
  overscroll-behavior-y: contain;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  &__items {
    font-size: 14px;
    height: calc(100vh - 113px);
    background-color: white;
    text-align: left;
    border-top: 1px solid $gray-2;
    overflow-y: scroll;
    overscroll-behavior-y: contain;
    &--item {
      padding: 13px 16px;
      border-bottom: 1px solid $gray-2;
      cursor: pointer;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    &--item:hover {
      background-color: $gray-3;
    }
  }
}

@media all and (min-width: $base-contents-width) {
  .suggest {
    display: none;
  }
}
</style>
